import React, { Fragment, useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useAnimation } from "framer-motion";
import Slider from "react-slick";
// AOS Animate imports
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Seo,
  Breadcrumb,
  ScrollTopBtn,
  SecSubTitle,
  SecTitle,
  InfoMedia,
} from "../../components";
import { HeaderThree, FooterOne } from "../../containers";
import { useLocation } from "react-router-dom";
import DCData from "../../data/dataCapture.json";
import "./Services.scss";

// Images and SVG
import phone1 from "../../assets/images/devices/1.png";
import bannerImage from "../../assets/images/bannerImage.png";
import globalReach from "../../assets/images/globalReach.png";
import ecommMadeSimple from "../../assets/images/ecommMadeSimple.png";
import oneTouch from "../../assets/images/oneTouch.png";
import whyChooseUsImage from "../../assets/images/whyChooseUs.png";
import whyChooseDatumart from "../../assets/images/whyChooseDatumart.png";
import line1 from "../../assets/images/line1.png";
import line2 from "../../assets/images/line2.png";
import revolutionizingEcomm from "../../assets/images/revolutionizingEcomm.png";
import whatWeHave from "../../assets/images/whatWeHave.png";
import cholaCafe from "../../assets/images/clients/cholacafe.png";
import croydon from "../../assets/images/clients/croydon.png";
import anjapparUK from "../../assets/images/clients/anjapparUK.png";

import {
  AIChipSvg,
  BrandMarketingSvg,
  DataDrivenSvg,
  RewardsSvg,
  CatalogManagementSvg,
  QRCodeSvg,
  OnlineShoppingSvg,
  AIStarSvg,
  MobileApp2Svg,
  PersonalizedSvg,
  KPI2Svg,
  CostEffectiveSvg,
  CustomerSupportSvg,
  UserAvatarSvg,
} from "../../assets/images/svg/Svgs";
// Common utils

import { colors } from "../../assets/js/common";
import { fadeIn, fadeUp } from "../../services/animationVariantions";

// Data
import {
  clientTestimonials,
  iconBoxTabContent,
  mobileSectionContent,
  whyChooseDatumartData,
  whyChooseUs,
} from "./data/data";
import { initializeDynamicImages } from "../../utils/dynamicImage";
import AnimatedNumber from "../../services/animatedNumber";
import ClampWithReadMore from "../../services/clampWithReadMore";
import ModalComponent from "../../services/modalComponent";
import { APIService } from "../../services/api-service";

const DatumartService = (data) => {
  const appLocation = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pageTitle, setPageTitle] = useState(
    "Digital Commerce and Marketing for Hyperlocal Businesses"
  );
  const [activeService, setActiveService] = useState(null);
  const [activeIconBox, setActiveIconBox] = useState("ic-1");
  const [activeFaq, setActiveFaq] = useState({
    id: 1,
    isActive: true,
    isOpen: true,
  });
  const [appModal, setAppModal] = useState({
    isOpen: false,
    title: "Example Title",
    subTitle: "Example SubTitle",
    content: "Example Content",
  });
  const controls = useAnimation();
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  let sliderRef = useRef(null);

  const sliderSettings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
  };

  const handleContactForm = (e) => {
    const { name, value } = e.target;
    setContactForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const [isLargeDevice, setIsLargeDevice] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const accordionClick = (accordionIndex) => {
    setActiveFaq((prevState) => ({
      ...prevState,
      id: accordionIndex,
      isActive: true,
      isOpen:
        prevState.id !== accordionIndex
          ? true
          : prevState.id === accordionIndex && prevState.isOpen
          ? !prevState.isOpen
          : !prevState.isOpen,
    }));
  };

  const readMore = (item) => {
    setAppModal((prevState) => ({
      ...prevState,
      title: item.name,
      subTitle: item.vendor ?? "Hello World",
      content: item.comment,
      isOpen: true,
    }));
  };

  const readMoreWcu = (item) => {
    setAppModal((prevState) => ({
      ...prevState,
      title: item.whyChooseUsTitle,
      subTitle: "",
      content: item.whyChooseUsSubTitle,
      isOpen: true,
    }));
  };

  const modalClose = () => {
    setIsError(false);
    setIsLoading(false);
    setAppModal((prevState) => ({
      ...prevState,
      isOpen: false,
    }));
    setIsContactModalOpen(false);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsError(false);
    const formData = new FormData(e.target);
    const entries = formData.entries();
    const data = Object.fromEntries(entries);
    const response = await APIService.sendEmail({
      to: "support@datumailabs.com",
      name: data.name,
      from: data.email,
      company: "Datumart",
      subject: "Enquiry Email",
      message: data.message,
    });
    setIsLoading(false);
    if (response.code !== 200) {
      setIsError(true);
      return;
    }
    e.target.reset();
    modalClose();
  };

  const onButtonClick = () => setIsContactModalOpen(true);

  useEffect(() => {
    // Check if window width matches lg breakpoint (typically 1024px)
    const mediaQuery = window.matchMedia("(min-width: 1024px)");

    // Set initial state
    setIsLargeDevice(mediaQuery.matches);

    // Update state when screen size changes
    const handleResize = (e) => {
      setIsLargeDevice(e.matches);
    };

    mediaQuery.addEventListener("change", handleResize);

    // Cleanup
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  // Only animate if it's a large device
  useEffect(() => {
    if (isLargeDevice) {
      controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0.5 },
      });
    } else {
      controls.set({ opacity: 1, y: 0 }); // Reset to final position without animation
    }
  }, [isLargeDevice, controls]);

  useEffect(() => {
    const splittedVals = appLocation.pathname.split("/");
    if (String(splittedVals[1]) === "dc") {
      const fSDeatils = DCData.services.find(
        (fData) => fData.id === parseInt(splittedVals[2])
      );
      setPageTitle(fSDeatils?.serviceDetails.seoTitle);
      setActiveService(fSDeatils);
    }
  }, [appLocation.pathname]);

  useEffect(() => {
    AOS.init();
    initializeDynamicImages("imageContainer");
  }, []);

  return (
    <Fragment>
      <Seo title={`${pageTitle}`} />
      <HeaderThree
        imgPath="../../images/full_logo.png"
        onButtonClick={onButtonClick}
      />
      <section className="space bg-white" id="home">
        <div className="container">
          <div className="d-flex flex-lg-row flex-column flex-column-reverse h-100">
            <motion.div
              variants={fadeIn("right", 0.05)}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              className="col-lg-6 col-12 d-flex flex-column justify-content-center flex-nowrap gap-24"
            >
              <font className="color-orange-1 bannerTtl-1 col-12">
                Digital Commerce made Simple
                <img src={line2} width={"100%"} alt="title line" />
              </font>
              <font className="color-dark-1 bannerSubTtl-1 col-12 py-20">
                Turn your dream business into reality with Datumart—design and
                brand your online store effortlessly. Launch and grow faster
                with personalized web and mobile storefronts that attract more
                customers online and in-store.
              </font>
            </motion.div>
            <motion.div
              variants={fadeIn("left", 0.05)}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              className="col-lg-6 col-12"
            >
              <div className="col-12 text-center">
                {/* <img src={bannerImage} alt="banner-image" width="100%" /> */}
                <img
                  src={revolutionizingEcomm}
                  alt="banner-image"
                  width="100%"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <section className="space bg-white" id="ourServices">
        <div className="container">
          <div className="row h-100">
            <div className="col-12">
              <div className="col-lg-12 d-flex flex-row flex-md-nowrap iconTabsWrapper">
                <motion.div
                  variants={fadeUp(0.5, 0.09, 1)}
                  initial="initial"
                  whileInView="animate"
                  viewport={{ once: true }}
                  className="col-lg-2 col solutionTab"
                >
                  <div
                    className={`iconBox ${
                      activeIconBox === "ic-1" && "active"
                    }`}
                    onClick={() => setActiveIconBox("ic-1")}
                  >
                    <div className="ttlIcon text-center">
                      <OnlineShoppingSvg
                        width="48"
                        height="48"
                        color={colors["orange-1"]}
                      />
                    </div>
                    <div className="iconTitle">Order and Delivery</div>
                  </div>
                </motion.div>
                <motion.div
                  variants={fadeUp(0.5, 0.09, 2)}
                  initial="initial"
                  whileInView="animate"
                  viewport={{ once: true }}
                  className="col-lg-2 col solutionTab d-flex justify-content-start"
                >
                  <div
                    className={`iconBox ${
                      activeIconBox === "ic-2" && "active"
                    }`}
                    onClick={() => setActiveIconBox("ic-2")}
                  >
                    <div className="ttlIcon text-center">
                      <BrandMarketingSvg
                        width="62"
                        height="62"
                        color={colors["orange-1"]}
                      />
                    </div>
                    <div className="iconTitle">Brand marketing</div>
                  </div>
                </motion.div>
                <motion.div
                  variants={fadeUp(0.5, 0.09, 3)}
                  initial="initial"
                  whileInView="animate"
                  viewport={{ once: true }}
                  className="col-lg-2 col solutionTab d-flex justify-content-center"
                >
                  <div
                    className={`iconBox ${
                      activeIconBox === "ic-3" && "active"
                    }`}
                    onClick={() => setActiveIconBox("ic-3")}
                  >
                    <div className="ttlIcon text-center">
                      <DataDrivenSvg
                        width="48"
                        height="48"
                        color={colors["orange-1"]}
                      />
                    </div>
                    <div className="iconTitle">Data Driven Insights</div>
                  </div>
                </motion.div>
                <motion.div
                  variants={fadeUp(0.5, 0.09, 4)}
                  initial="initial"
                  whileInView="animate"
                  viewport={{ once: true }}
                  className="col-lg-2 col solutionTab d-flex justify-content-center"
                >
                  <div
                    className={`iconBox ${
                      activeIconBox === "ic-4" && "active"
                    }`}
                    onClick={() => setActiveIconBox("ic-4")}
                  >
                    <div className="ttlIcon text-center">
                      <RewardsSvg
                        width="48"
                        height="48"
                        color={colors["orange-1"]}
                      />
                    </div>
                    <div className="iconTitle">Rewards and Loyalty</div>
                  </div>
                </motion.div>
                <motion.div
                  variants={fadeUp(0.5, 0.09, 5)}
                  initial="initial"
                  whileInView="animate"
                  viewport={{ once: true }}
                  className="col-lg-2 col solutionTab d-flex justify-content-center"
                >
                  <div
                    className={`iconBox ${
                      activeIconBox === "ic-5" && "active"
                    }`}
                    onClick={() => setActiveIconBox("ic-5")}
                  >
                    <div className="ttlIcon text-center">
                      <CatalogManagementSvg
                        width="48"
                        height="48"
                        color={colors["orange-1"]}
                      />
                    </div>
                    <div className="iconTitle">Catalog Management</div>
                  </div>
                </motion.div>
                <motion.div
                  variants={fadeUp(0.5, 0.09, 6)}
                  initial="initial"
                  whileInView="animate"
                  viewport={{ once: true }}
                  className="col-lg-2 col solutionTab d-flex justify-content-end"
                >
                  <div
                    className={`iconBox ${
                      activeIconBox === "ic-6" && "active"
                    }`}
                    onClick={() => setActiveIconBox("ic-6")}
                  >
                    <div className="ttlIcon text-center">
                      <QRCodeSvg
                        width="48"
                        height="48"
                        color={colors["orange-1"]}
                      />
                    </div>
                    <div className="iconTitle">QR Code Promotions</div>
                  </div>
                </motion.div>
              </div>
            </div>
            <div className="col-12 mt-50">
              <div className="iconBoxContainer d-flex flex-lg-row flex-column py-20 px-50 align-items-center">
                <motion.div
                  variants={fadeUp(0.5)}
                  initial="initial"
                  key={iconBoxTabContent[activeIconBox]?.tabTitle}
                  whileInView="animate"
                  viewport={{ once: true }}
                  className="col-12 col-lg-6 d-flex flex-column gap-20 justify-content-center"
                >
                  <font className="color-orange-1 bannerTtl-2 col-12">
                    {iconBoxTabContent[activeIconBox]?.tabTitle}
                  </font>
                  <font className="color-dark font-20 col-12 py-20">
                    {iconBoxTabContent[activeIconBox]?.tabContent}
                  </font>
                </motion.div>
                <motion.div
                  variants={fadeUp(0.5)}
                  initial="initial"
                  key={iconBoxTabContent[activeIconBox]?.image}
                  whileInView="animate"
                  viewport={{ once: true }}
                  className="col-12 col-lg-6 text-end"
                >
                  <img
                    src={iconBoxTabContent[activeIconBox]?.image}
                    alt="iphone-image"
                    width="100%"
                  />
                </motion.div>
              </div>
              <div className="col-lg-9 col-11 mx-auto pt-50 text-center">
                <p className="bannerSubTtl-1 color-dark">
                  <b>
                    Subscribe to our platform now and effortlessly create your
                    very own gamified digital channels (in web, social, mobile)
                    powered by AI and data Insights !
                  </b>
                  <br />
                  <u>
                    Avail 65 features and 55 plug and play options to get
                    started in 24 hours !
                  </u>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="space bg-dark-12" id="globalReach">
        <div className="container">
          <div className="d-flex flex-lg-row flex-column flex-column-reverse h-100">
            <motion.div
              variants={fadeIn("right", 0.05)}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              className="col-12 col-lg-6"
            >
              <div className="col-11 mr-auto d-flex flex-column justify-content-start flex-nowrap gap-24">
                <font className="color-orange-1 bannerTtl-1 col-12">
                  Global Reach
                </font>
                <font className="color-dark-1 bannerSubTtl-1 col-12 pb-20">
                  Our platform is trusted by over 750 active users globally,
                  including businesses of all sizes. We are committed to
                  providing exceptional tools and services to help our clients
                  achieve their goals and optimize their operations.
                </font>
                <div></div>
                <div className="color-dark-1 col-12 counterTextWrapper">
                  <font className="ml-10 font-20 fw-medium counterTextValue pb-2">
                    Trusted By
                  </font>
                  <div className="ml-10 d-flex pb-2">
                    <AnimatedNumber
                      className="d-flex ml-10 font-60 fw-bold color-orange-1"
                      number={750}
                      animationDuration={1000}
                    />
                    <font className="font-60 fw-bold color-orange-1">+</font>
                  </div>
                  <font className="ml-10 font-20 fw-medium counterTextValue">
                    Platform Users
                  </font>
                </div>
              </div>
            </motion.div>
            <motion.div
              variants={fadeIn("left", 0.05)}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              className="col-12 col-lg-6"
            >
              <div className="col-12 text-center">
                <img src={globalReach} alt="banner-image" width="100%" />
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <section className="space space-extra-bottom" id="ourSolutions">
        <div className="container">
          <div className="my-3">
            <div className="center-line"></div>
          </div>
          <div className="row flex-column">
            <div className="col-12 mb-4 text-center">
              <SecSubTitle>
                <i className="fas fa-bring-forward" />
                Our Solutions
              </SecSubTitle>
              <SecTitle className="h1 mb-3 pb-3 text-capitalize fs-4">
                Everything you need to launch and grow your business
              </SecTitle>
            </div>
            <div className="feature-section">
              <motion.div
                variants={fadeUp(0.5, 0.05)}
                initial="initial"
                whileInView="animate"
                viewport={{ once: true }}
                className="colFeature"
              >
                <div className="text-center d-flex flex-column gap-12 align-items-center">
                  <MobileApp2Svg
                    width="32"
                    height="32"
                    color={colors["orange-1"]}
                  />
                  <font className="fw-semibold font-18 color-dark-3 text-center py-2">
                    Mobile App to strengthen your branding
                  </font>
                  <font className="fw-normal font-17 color-dark-3 text-center">
                    A personalized mobile app gives you complete control over
                    your brand, customer experience and data, unlike aggregator
                    platforms that limit visibility and charge high commissions.
                    Plus, you avoid competing with other brands on the same
                    platform, ensuring stronger brand loyalty, higher profit
                    margins, and long-term growth
                  </font>
                </div>
              </motion.div>
              <motion.div
                variants={fadeUp(0.5, 0.1)}
                initial="initial"
                whileInView="animate"
                viewport={{ once: true }}
                className="colFeature"
              >
                <div className="text-center d-flex flex-column gap-12 align-items-center">
                  <PersonalizedSvg
                    width="32"
                    height="32"
                    color={colors["orange-1"]}
                  />
                  <font className="fw-semibold font-18 color-dark-3 text-center py-2">
                    Enhanced Personalized Customer Experience
                  </font>
                  <font className="fw-normal font-17 color-dark-3 text-center">
                    Unlock 65 built-in features and 55 plug-and-play tools, all
                    personalized to your brand's needs. With your own app, you
                    gain full control over your brand experience and customer
                    engagement, ensuring every interaction is uniquely yours.
                  </font>
                </div>
              </motion.div>
              <motion.div
                variants={fadeUp(0.5, 0.05)}
                initial="initial"
                whileInView="animate"
                viewport={{ once: true }}
                className="colFeature"
              >
                <div className="text-center d-flex flex-column gap-12 align-items-center">
                  <KPI2Svg width="32" height="32" color={colors["orange-1"]} />
                  <font className="fw-semibold font-18 color-dark-3 text-center py-2">
                    Merchant KPI Insights Assistant
                  </font>
                  <font className="fw-normal font-17 color-dark-3 text-center">
                    AI-powered analytics tool that helps business owners track
                    and understand their key performance indicators in
                    real-time. It provides personalized recommendations and
                    actionable insights by analyzing sales trends, and
                    operational metrics, enabling merchants to make data-driven
                    decisions for business growth.
                  </font>
                </div>
              </motion.div>
              <motion.div
                variants={fadeUp(0.5, 0.1)}
                initial="initial"
                whileInView="animate"
                viewport={{ once: true }}
                className="colFeature"
              >
                <div className="text-center d-flex flex-column gap-12 align-items-center">
                  <CostEffectiveSvg
                    width="32"
                    height="32"
                    color={colors["orange-1"]}
                  />
                  <font className="fw-semibold font-18 color-dark-3 text-center py-2">
                    Cost-effective Infrastructure
                  </font>
                  <font className="fw-normal font-17 color-dark-3 text-center">
                    Our Cloud-based infrastructure delivers secure, reliable,
                    and scalable solutions while optimizing costs through
                    efficient resource management and automated scaling.
                    {/* Our Cloud-based infrastructure delivers secure, reliable,
                    and scalable solutions while optimizing costs through
                    efficient resource management and automated scaling.
                    Leveraging cutting-edge technology and best practices, we
                    ensure maximum uptime and performance without compromising
                    on security or budget constraints. */}
                  </font>
                </div>
              </motion.div>
              <motion.div
                variants={fadeUp(0.5, 0.05)}
                initial="initial"
                whileInView="animate"
                viewport={{ once: true }}
                className="colFeature"
              >
                <div className="text-center d-flex flex-column gap-12 align-items-center">
                  <AIStarSvg
                    width="32"
                    height="32"
                    color={colors["orange-1"]}
                  />
                  <font className="fw-semibold font-18 color-dark-3 text-center py-2">
                    Digital Marketing with AI Tools
                  </font>
                  <font className="fw-normal font-17 color-dark-3 text-center">
                    AI-driven tools help you to create personalized,
                    high-quality content effortlessly, and deliver intuitive
                    product recommendations and instant responses to enhance
                    customer engagement and satisfaction.
                  </font>
                </div>
              </motion.div>
              <motion.div
                variants={fadeUp(0.5, 0.1)}
                initial="initial"
                whileInView="animate"
                viewport={{ once: true }}
                className="colFeature"
              >
                <div className="text-center d-flex flex-column gap-12 align-items-center">
                  <CustomerSupportSvg
                    width="32"
                    height="32"
                    color={colors["orange-1"]}
                  />
                  <font className="fw-semibold font-18 color-dark-3 text-center py-2">
                    Strong technical team with 24/7 support
                  </font>
                  <font className="fw-normal font-17 color-dark-3 text-center">
                    Our dedicated technical experts provide round-the-clock
                    support, ensuring rapid problem resolution and proactive
                    system maintenance to keep your business running smoothly.
                  </font>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      <section className="space bg-white" id="commerceMadeSimple">
        <div className="container">
          <div className="d-flex flex-lg-row flex-column flex-column-reverse h-100 align-items-center">
            <motion.div
              variants={fadeIn("right", 0.05)}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              className="col-12 col-lg-6"
            >
              <div className="col-11 mr-auto d-flex flex-column justify-content-start flex-nowrap gap-24">
                <font className="color-orange-1 bannerTtl-1 col-12">
                  Digital Commerce made simple
                </font>
                <font className="color-dark-1 bannerSubTtl-1 col-12 pb-20">
                  Datumart helps to create personalized, white label digital
                  commerce platform to manage your business operations and
                  customer engagement. Our solution offers a seamless,
                  user-friendly way for business owners to manage their
                  operations online—without needing any technical skills.
                </font>

                {/* <div className="position-relative d-flex">
                  <span className="buttonWrapper position-relative">
                    <span className="ol-1"></span>
                    <button
                      className="btnOrange customBtn"
                      type="button"
                      title="View More"
                    >
                      Read More
                    </button>
                    <span className="ol-2"></span>
                  </span>
                </div> */}
              </div>
            </motion.div>
            <motion.div
              variants={fadeIn("left", 0.05)}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              className="col-10 col-lg-6"
            >
              <div className="col-12 text-center">
                <img
                  src={ecommMadeSimple}
                  alt="Ecomm Made Simple by Datumart"
                  width="100%"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <section className="space bg-white" id="oneTouchControl">
        <div className="container">
          <div className="d-flex flex-lg-row flex-column flex-colum-reverse h-100 align-items-center">
            <motion.div
              variants={fadeIn("right", 0.05)}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              className="col-12 col-lg-6"
            >
              <div className="col-12 text-center">
                <img
                  src={oneTouch}
                  alt="One Touch Controllable service in Eccommerce by Datumart"
                  width="100%"
                />
              </div>
            </motion.div>
            <motion.div
              variants={fadeIn("left", 0.05)}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
              className="col-12 col-lg-6"
            >
              <div className="col-12 col-lg-11 ml-auto d-flex flex-column justify-content-start flex-nowrap gap-24">
                <font className="color-orange-1 bannerTtl-1 col-12">
                  One Touch Control
                </font>
                <div className="col-12 d-flex flex-row gap-0 gap-lg-2">
                  <i className="fas font-12 color-dark-9 fa-dot-circle mr-2 mt-2"></i>
                  <font className="color-dark-1 font-20 col-12 pb-10">
                    No more tiring manual updates, no more headaches from
                    updating your website and mobile app separately. Self
                    service with no technical skills required. One click to
                    update stock inventory across all channels
                  </font>
                </div>
                <div className="col-12 d-flex flex-row gap-0 gap-lg-2">
                  <i className="fas font-12 color-dark-9 fa-dot-circle mr-2 mt-2"></i>
                  <font className="color-dark-1 font-20 col-12 pb-10">
                    Daily prices syncs between your website, mobile app, and
                    delivery platforms
                  </font>
                </div>
                <div className="col-12 d-flex flex-row gap-0 gap-lg-2">
                  <i className="fas font-12 color-dark-9 fa-dot-circle mr-2 mt-2"></i>
                  <font className="color-dark-1 font-20 col-12 pb-10">
                    Weekly preset - publishes daily deals and promotional
                    banners
                  </font>
                </div>
                <div className="col-12 d-flex flex-row gap-0 gap-lg-2">
                  <i className="fas font-12 color-dark-9 fa-dot-circle mr-2 mt-2"></i>
                  <font className="color-dark-1 font-20 col-12 pb-10">
                    Single click updates digital menu boards in-store and online
                    store
                  </font>
                </div>

                {/* <div>
                  <button
                    className="btnOrange customBtn"
                    type="button"
                    title="View More"
                  >
                    Read More
                  </button>
                </div> */}
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* <section className="space app-bg-light">
        <div className="container">
          <div className="row h-100">
            <div className="col-12">
              <div className="col-10 d-flex flex-column justify-content-start flex-nowrap gap-24">
                <font className="col-12 mr-auto color-orange-1 bannerTtl-1">
                  Integrated Platform to focus your business growth
                </font>
              </div>
            </div>
            <div className="col-12">
              <div className="col-7 ml-auto text-start d-flex flex-row gap-2">
                <i className="far fs-5 fa-check-circle mr-2 mt-1"></i>
                <font className="color-dark-1 font-20 col-12 pb-20">
                  Unites all digital operations under one roof, keeps more
                  profits in local hands, build genuine connections with
                  customers, preserve what makes each stores unique
                </font>
              </div>
            </div>
            <div className="col-12 d-flex flex-row gap-12 pt-50">
              {mobileSectionContent.map((item, index) => {
                return (
                  <div className="col-4 d-flex flex-column" key={index}>
                    <div className="col-12 text-center">
                      <img
                        src={item.image}
                        width="75%"
                        alt={`mobile-${index + 1}`}
                      />
                    </div>
                    <font className="color-dark-1 bannerTtl-3 text-center col-12 pt-4">
                      {item.title}
                    </font>
                    <font className="color-dark-1 bannerSubTtl-2 text-center col-11 mx-auto py-4">
                      {item.content}
                    </font>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section> */}
      <section className="space bg-dark-1" id="onBoarding">
        <div className="container">
          <div className="row h-100">
            <div className="col-12 d-flex flex-column justify-content-center gap-24">
              <font className="color-orange-1 bannerTtl-2 col-12 text-center">
                Onboard your E-Commerce website in 24 hrs Get 7 days free trial
                today
              </font>
              <font className="color-white bannerSubTtl-1 col-xxl-8 mx-xxl-auto text-center">
                No payment information is required, you’ll be able to setup and
                take advantage of Datumart platform right away.
              </font>
              <div className="col-lg-5 col-10 mx-auto text-center justify-content-center position-relative d-flex flex-row">
                {/* <input
                  className="inputWithButton"
                  type="email"
                  title="Enter Email"
                  placeholder="Enter your email"
                  style={{ visibility: "hidden" }}
                /> */}
                <button
                  className="btnDark customBtn"
                  type="button"
                  title="Get Started"
                  onClick={onButtonClick}
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="space space-extra-bottom" id="whyChooseUs">
        <div className="container">
          <div className="my-3">
            <div className="center-line" style={{ marginInline: 0 }}></div>
          </div>
          <div className="col-12 text-start">
            <SecSubTitle>
              <i className="fas fa-bring-forward" />
              About Us
            </SecSubTitle>
          </div>
          <div className="col-12 text-start position-relative">
            <SecTitle className="mb-0 shadowTitle">Datumart</SecTitle>
            <SecTitle className="shadowSubTitle mb-0">Who We Are ?</SecTitle>
          </div>
          <div className="col-12 text-start position-relative">
            <font className="fw-normal font-17 color-dark-3 text-center">
              We are a Technology and innovation-driven company dedicated to
              empowering small businesses with cutting-edge digital solutions.
              Our mission is to help entrepreneurs grow, scale, and succeed in
              the digital economy. We leverage the latest advancements in
              e-commerce, AI, and automation to create powerful, user-friendly
              platforms that enable businesses to seamlessly expand their
              products and services. Whether you're starting out or scaling up,
              our platform is designed to drive efficiency, profitability, and
              long-term success. Join us in shaping the future of digital
              commerce!
            </font>
          </div>
          <div className="d-flex flex-lg-row flex-column flex-colum-reverse">
            <div className="col-12 col-lg-6 mb-4 mr-auto">
              <div className="col-11 mr-auto text-center">
                <img src={whatWeHave} alt="Why Choose Us FAQ By Datumart" />
              </div>
            </div>
            <div className="col-12 col-lg-6 pt-50">
              {whyChooseDatumartData?.map((mItem, mIndex) => {
                const isActive =
                  activeFaq.id === mIndex + 1 && activeFaq.isActive;
                const isOpen = activeFaq.id === mIndex + 1 && activeFaq.isOpen;
                return (
                  <div
                    key={mIndex}
                    className={`col-12 col-lg-11 text-start faq accordionWrapper ${
                      isActive ? "isActive" : ""
                    } ${isOpen ? "isOpen" : ""}`}
                  >
                    <div
                      className={`accordionHeader d-flex flex-row gap-4 justify-content-between py-20`}
                      onClick={() => accordionClick(mIndex + 1)}
                    >
                      <h6 className="accordionTitle mb-0">{mItem.header}</h6>
                      <i
                        className={`fas fa-chevron-${isOpen ? "up" : "down"}`}
                      />
                    </div>
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{
                            height: "auto",
                            opacity: 1,
                            transition: {
                              height: {
                                duration: 0.3,
                                ease: "easeInOut",
                              },
                              opacity: {
                                duration: 0.25,
                                delay: 0.05,
                              },
                            },
                          }}
                          exit={{
                            height: 0,
                            opacity: 0,
                            transition: {
                              height: {
                                duration: 0.3,
                                ease: "easeInOut",
                              },
                              opacity: {
                                duration: 0.25,
                              },
                            },
                          }}
                        >
                          <div className="accordionContent py-20">
                            {mItem.content}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      {/* <section className="space bg-white" id="blogs">
        <div className="container">
          <div className="my-3">
            <div className="center-line"></div>
          </div>
          <div className="row h-100">
            <div className="col-12 d-flex flex-column justify-content-start flex-nowrap gap-24">
              <div className="col-12 mb-4">
                <div className="col-12 text-center">
                  <SecSubTitle>
                    <i className="fas fa-bring-forward" />
                    Our Latest Blogs
                  </SecSubTitle>
                  <SecTitle className="h1 mb-3 pb-3 text-capitalize fs-4">
                    Latest News From The Blog & Article
                  </SecTitle>
                </div>
              </div>
            </div>
            <div className="col-12 d-flex flex-column gap-8 pt-9">
              <div className="col-12 d-flex flex-row gap-12 bg-dark-3 p-9 rounded-4">
                <div className="col-5">
                  <img
                    src={
                      "https://wordpress.vecurosoft.com/techbiz/wp-content/uploads/2022/08/blog1-485x220.jpg"
                    }
                    className="rounded-3"
                    alt="banner-image"
                  />
                </div>
                <div className="col-7 d-flex flex-column justify-content-evenly px-8">
                  <font className="color-orange-1 bannerSubTtl-1 col-12">
                    10 Aug, 2022 POST BY: Rodja Hartmann
                  </font>
                  <font className="color-white font-24 fw-bold col-12">
                    Richard McClintock, a Latin scholar from
                  </font>
                  <div className="col-12">
                    <button type="button" className="btnDark customBtn">
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 d-flex flex-column gap-8 pt-9">
              <div className="col-12 d-flex flex-row gap-12 bg-dark-12 p-9 rounded-4">
                <div className="col-5">
                  <img
                    src={
                      "https://wordpress.vecurosoft.com/techbiz/wp-content/uploads/2022/08/blog4-485x220.jpg"
                    }
                    className="rounded-3"
                    alt="banner-image"
                  />
                </div>
                <div className="col-7 d-flex flex-column justify-content-evenly px-8">
                  <font className="color-orange-1 bannerSubTtl-1 col-12">
                    10 Aug, 2022 POST BY: Rodja Hartmann
                  </font>
                  <font className="color-dark-2 font-24 fw-bold col-12">
                    Richard McClintock, a Latin scholar from
                  </font>
                  <div className="col-12">
                    <button type="button" className="btnOrange customBtn">
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 d-flex flex-column gap-8 pt-9">
              <div className="col-12 d-flex flex-row gap-12 bg-dark-3 p-9 rounded-4">
                <div className="col-5">
                  <img
                    src={
                      "https://wordpress.vecurosoft.com/techbiz/wp-content/uploads/2022/08/blog1-485x220.jpg"
                    }
                    className="rounded-3"
                    alt="banner-image"
                  />
                </div>
                <div className="col-7 d-flex flex-column justify-content-evenly px-8">
                  <font className="color-orange-1 bannerSubTtl-1 col-12">
                    10 Aug, 2022 POST BY: Rodja Hartmann
                  </font>
                  <font className="color-white font-24 fw-bold col-12">
                    Richard McClintock, a Latin scholar from
                  </font>
                  <div className="col-12">
                    <button type="button" className="btnDark customBtn">
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="space bg-white" id="aboutUs">
        <div className="container">
          <div className="row h-100">
            <div
              className="col-12 mx-auto position-relative"
              style={{ height: "600px" }}
            >
              {/* <div
                id="imageContainer"
                className="dynamic-image-container"
                data-image-count="1"
                data-image-height="150"
                data-image-width="150"
                style={{ height: "100%" }}
              ></div> */}
              <div className="blurredContainer"></div>
              <div
                className="col-12 d-flex flex-column justify-content-center gap-24 position-relative"
                style={{ height: "100%", zIndex: 5, opacity: 1 }}
              >
                <font className="color-orange-1 bannerTtl-1 col-12 text-center">
                  Grow Local, Go Digital, Stay Global
                </font>
                <font className="color-dark-1 bannerSubTtl-1 col-xxl-8 col-lg-10 col-12 mx-auto text-center">
                  Datumart is ready to elevate your brand identity with
                  innovative digital commerce solutions to scale your business.
                  Join the growing community of businesses achieving success
                  with Datum Growth Solutions.
                </font>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Dev check in dev mode */}
      {/* <section className="space space-extra-bottom">
        <div className="container">
          <div className="row flex-column">
            <div className="col-12 mb-4">
              <div className="col-12">
                <SecSubTitle>
                  <i className="fas fa-bring-forward" />
                  Our Operational Approach
                </SecSubTitle>
                <SecTitle className="h1 mb-3 pb-3 text-capitalize">
                  Key Features
                </SecTitle>
              </div>
            </div>
            <div className="d-flex flex-row col-12 flex-wrap">
              <div className="col-12 col-lg-6 col-xxl-6 pt-5">
                <div className="process-info-media process-media-order pr-8">
                  <div className="process-media-icon">01</div>
                  <div className="process-media-body">
                    <span className="process-media-label">
                      Mobile App to strengthen your branding
                    </span>
                    <div className="process-media-link font-18">
                      Contrary to popular belief, Lorem Ipsum is not simply
                      random text. It has roots in a piece of classical Latin
                      literature from 45 BC, making it over 2000 years old.
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 col-xxl-6 pt-5">
                <div className="process-info-media process-media-order pr-8">
                  <div className="process-media-icon">02</div>
                  <div className="process-media-body">
                    <span className="process-media-label">
                      Enhanced Personalized Customer Experience
                    </span>
                    <div className="process-media-link font-18">
                      - With In-built 65 features with 55 plug-n-play (Basic
                      Plan)
                      <br />- 10 customizable features specific to your business
                      needs
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 col-xxl-6 pt-5">
                <div className="process-info-media process-media-order pr-8">
                  <div className="process-media-icon">03</div>
                  <div className="process-media-body">
                    <span className="process-media-label">
                      Merchant KPI Insights Assistant
                    </span>
                    <div className="process-media-link font-18">
                      Track your business performance
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 col-xxl-6 pt-5">
                <div className="process-info-media process-media-order pr-8">
                  <div className="process-media-icon">04</div>
                  <div className="process-media-body">
                    <span className="process-media-label">
                      Cost-effective Infrastructure
                    </span>
                    <div className="process-media-link font-18">
                      Cloud Based, Secure, Reliable, Scalable
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 col-xxl-6 pt-5">
                <div className="process-info-media process-media-order pr-8">
                  <div className="process-media-icon">05</div>
                  <div className="process-media-body">
                    <span className="process-media-label">
                      Digital Marketing with AI Tools
                    </span>
                    <div className="process-media-link font-18">
                      In-app Push Notify Offers & Discounts to potential
                      customers through various digital channels
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 col-xxl-6 pt-5">
                <div className="process-info-media process-media-order pr-8">
                  <div className="process-media-icon">06</div>
                  <div className="process-media-body">
                    <span className="process-media-label">
                      Strong technical team with 24/7 support
                    </span>
                    <div className="process-media-link font-18">
                      Contrary to popular belief, Lorem Ipsum is not simply
                      random text. It has roots in a piece of classical Latin
                      literature from 45 BC, making it over 2000 years old.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Client Testimonials */}
      <section className="space space-extra-bottom" id="clientSays">
        <div className="container">
          <div className="my-3">
            <div className="center-line" style={{ marginInline: 0 }}></div>
          </div>
          <div className="d-flex flex-lg-row flex-column">
            <div className="col-12 col-lg-6 mb-4 mr-auto">
              <div className="col-12 text-start">
                <SecSubTitle>
                  <i className="fas fa-bring-forward" />
                  Customer Testimonial
                </SecSubTitle>
              </div>
              <div className="col-12 text-start position-relative">
                <SecTitle className="mb-0 shadowTitle">Clients</SecTitle>
                <SecTitle className="shadowSubTitle mb-0">
                  What Clients Say
                </SecTitle>
              </div>
              <div className="col-12 col-lg-11 mr-auto text-start subTitle-1">
                In today’s world, building a business also means you’ll need a
                strong website and social media presence. These can help you
                learn your customers better.
              </div>
              <div className="col-lg-11 mr-auto">
                {/* <div className="clientLogoWrapper d-flex flex-row gap-8 align-items-center">
                  <div className="clientLogo">
                    <img src="images/clients/cholaCafe.png" alt="client-logo" />
                  </div>
                  <div className="clientLogo">
                    <img src="images/clients/croydon.png" alt="client-logo" />
                  </div>
                  <div className="clientLogo">
                    <img src="images/clients/cholaCafe.png" alt="client-logo" />
                  </div>
                  <div className="clientLogo">
                    <img src="images/clients/croydon.png" alt="client-logo" />
                  </div>
                </div> */}
                <Slider
                  {...sliderSettings}
                  ref={(slider) => (sliderRef = slider)}
                >
                  <div className="clientLogo" title="Anjappar UK" onClick={() => window.open("https://anjapparuk.com", "_blank")}>
                        <img
                        src={anjapparUK}
                        alt="AnjapparUK Client Logo"
                        title="AnjapparUK"
                      />
                      <h6 className="text-center mt-2 font-14">
                        AnjapparUK, UK, London
                      </h6>
                  </div>
                  <div className="clientLogo" title="CholaCafe Bentonville, US" onClick={() => window.open("https://www.cholacafebentonville.com", "_blank")}>
                    <img
                      src={cholaCafe}
                      alt="CholaCafe Client Logo"
                      title="CholaCafe Bentonville, US"
                    />
                    <h6 className="text-center mt-2 font-14">
                      CholaCafe Bentonville, US
                    </h6>
                  </div>
                  <div className="clientLogo" title="Croydon FoodStation, UK" onClick={() => window.open("https://www.cholacafebentonville.com", "_blank")}>
                    <img
                      src={croydon}
                      alt="Croydon Client Logo"
                      title="Croydon FoodStation, UK"
                    />
                    <h6 className="text-center mt-2 font-14">
                      Croydon FoodStation, UK
                    </h6>
                  </div>
                </Slider>
                <div className="sliderButtons justify-content-center d-flex flex-row gap-12">
                  <button
                    type="button"
                    title="Previous Client"
                    className="customBtn prevBtn"
                    onClick={() => sliderRef?.slickPrev()}
                  >
                    <i className="far fa-arrow-left mx-1 font-16"></i>
                    {/* Previous */}
                  </button>
                  <button
                    type="button"
                    title="Next Client"
                    className="customBtn nextBtn"
                    onClick={() => sliderRef?.slickNext()}
                  >
                    {/* Next */}
                    <i className="far fa-arrow-right mx-1 font-16"></i>
                  </button>
                </div>
              </div>
              <div></div>
            </div>
            <div className="col-12 col-lg-6 pt-50">
              <div className="clientTestimonialWrapper">
                {clientTestimonials.map((item, index) => {
                  return (
                    <div key={index} className="clientTestimonialItem">
                      <div className="clientDetailWrapper d-flex flex-column gap-8 align-items-start">
                        <div className="col-12 d-flex flex-row gap-8">
                          <div className="col-lg-3 col-3">
                            <div className="clientDetailImage">
                              {/* <img src={item.image} alt="client-image" /> */}
                              <UserAvatarSvg
                                width={"64px"}
                                height={"64px"}
                                color={colors["orange-1"]}
                              />
                            </div>
                          </div>
                          <div className="d-flex flex-column overflow-hidden col-10 col-lg-9">
                            <div className="clientDetailName font-16 fw-semibold">
                              {item.name}
                            </div>
                            <div className="clientDetailVendor font-14 color-dark-1">
                              {item.vendor}
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-12 clientComment pt-2 font-16">
                          {item.comment}
                          <ClampWithReadMore text={item.comment} lines={4} />
                        </div> */}
                        <div className="col-12 pt-2 font-16">
                          <ClampWithReadMore
                            text={item.comment}
                            lines={4}
                            redMoreClick={() => readMore(item)}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* All in-one suits */}
      <section className="app-bg-light py-30">
        <div className="container">
          <div className="my-3">
            <div className="center-line"></div>
          </div>
          <div className="row h-100">
            <div className="col-12 mb-4 text-center">
              <SecSubTitle>
                <i className="fas fa-bring-forward" />
                Our Solutions
              </SecSubTitle>
              <SecTitle className="h1 mb-3 pb-3 text-capitalize fs-4">
                All-in-One Datumart Creative Support Services
              </SecTitle>
            </div>
            <div className="col-12 d-flex flex-lg-row flex-column gap-30 gap-lg-0 pt-50">
              {whyChooseUs.map((item, index) => {
                return (
                  <div
                    className="col-12 col-lg-4 d-flex flex-column px-4"
                    key={index}
                  >
                    <div className="col-10 mx-auto col-lg-12 position-relative wcsWrapper">
                      <div className="ribbonTag">
                        <font className="ribbonTagText">{item.id}</font>
                      </div>
                      <div
                        className="wcuContainer d-flex justify-content-end"
                        style={{
                          backgroundColor: colors.white,
                          backgroundImage: `url(${item.image})`,
                          backgroundSize: "contain",
                          backgroundPosition: "0 35%",
                        }}
                      >
                        <div className="wcuOverlap">
                          <div className="wcuContentWrapper">
                            <div className="wcuTextWrapper d-flex flex-column gap-25">
                              <font className="wcuTitle color-white font-18">
                                {item.whyChooseUsTitle}
                              </font>
                              <ClampWithReadMore
                                text={item.whyChooseUsSubTitle}
                                lines={4}
                                redMoreClick={() => readMoreWcu(item)}
                                className="wcuSubTitle color-white font-16"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="col-12 py-4">
              <div className="col-10 mx-auto text-center d-flex flex-row gap-2">
                {/* <i className="far fs-5 fa-check-circle mr-2 mt-1"></i> */}
                <font className="color-dark-1 subTitle-1 col-12 py-20">
                  Unlock your brand's potential with our All-in-One Creative
                  Support Services, specifically designed to empower e-commerce
                  businesses. Our comprehensive services integrate powerful
                  design, editing, and collaboration features into a seamless
                  platform, tailored to bring your ideas to life. Elevate your
                  online presence and optimize your visual assets with intuitive
                  tools that offer unmatched versatility, making it easier than
                  ever to create compelling, on-brand content.
                </font>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <FooterOne /> */}
      <footer
        className="footer-wrapper background-image"
        style={{ backgroundColor: "#001524" }}
      >
        <div className="copyright-wrap" style={{ background: "#001524" }}>
          <div className="container">
            <div className="row">
              <p className="copyright-text">
                Copyright <i className="fal fa-copyright" />{" "}
                {new Date().getFullYear()} Datumart
              </p>
              <p className="copyright-text">
                PoweredBy{" "}
                <a href="https://www.datumailabs.com" target="__blank">
                  Datumailabs
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
      <ScrollTopBtn />

      <ModalComponent
        isOpen={appModal.isOpen}
        onClose={modalClose}
        subTitle={appModal.subTitle}
        title={appModal.title}
        content={appModal.content}
      />
      <ModalComponent
        isOpen={isContactModalOpen}
        onClose={modalClose}
        title={"Enquiry Form"}
      >
        <div className="col-12">
          <form name="enquiryForm" onSubmit={submitForm} id="enquiryForm">
            <div className="row">
              <div className="col-12 col-lg-6">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    className="form-control appInput"
                    id="name"
                    name="name"
                    value={contactForm.name}
                    onChange={handleContactForm}
                    required
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    className="form-control appInput"
                    id="email"
                    name="email"
                    value={contactForm.email}
                    onChange={handleContactForm}
                    required
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    className="appInput"
                    id="message"
                    name="message"
                    rows="5"
                    value={contactForm.message}
                    onChange={handleContactForm}
                    required
                  ></textarea>
                </div>
              </div>
              <div className="col-12">
                {/* <button type="submit" className="btn btn-primary">
                  Submit
                </button> */}
                <div className="position-relative d-flex">
                  <span className="buttonWrapper position-relative">
                    <span className="ol-1"></span>
                    <button
                      id="enquirySubmit"
                      className="btnOrange customBtn"
                      type="submit"
                      title="Send Enquiry"
                      disabled={isLoading}
                    >
                      {isLoading && "Sending..."}
                      {isError && "Try Again"}
                      {!isLoading && !isError && "Submit"}
                    </button>
                    <span className="ol-2"></span>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default DatumartService;
